export default __webpack_public_path__ + "static/media/9.47b1e789.jpg";